/** One link in the public footer. */
export interface FooterLink {
  label: string;
  href: string;
}

/** A headed column of links in the public footer. */
export interface FooterColumn {
  heading: string;
  links: FooterLink[];
}

/** Link columns in the public footer, left to right. */
export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    heading: "Company",
    links: [
      { label: "About Nowadays", href: "/company" },
      { label: "Newsroom", href: "/press" },
      { label: "Our team", href: "/team" },
      { label: "Careers", href: "/careers" },
      { label: "Planner profiles", href: "/global-account-managers" },
      { label: "Pricing", href: "/pricing" },
      { label: "Partner with us", href: "/partner" },
      { label: "Referral program", href: "/referral" },
    ],
  },
  {
    heading: "Solutions",
    links: [
      { label: "Startups", href: "/solutions/startups" },
      { label: "Enterprise", href: "/solutions/enterprise" },
      { label: "People teams", href: "/people-teams" },
      { label: "Executive assistants", href: "/executive-assistants" },
      { label: "Event marketers", href: "/event-marketers" },
      { label: "Agencies", href: "/agencies" },
      { label: "Travel agents", href: "/travel-agents" },
      { label: "Hoteliers & venues", href: "/partners" },
    ],
  },
  {
    heading: "Products",
    links: [
      { label: "Venue sourcing", href: "/venue-sourcing" },
      { label: "Registration", href: "/registration" },
      { label: "Cost estimator", href: "/cost-estimator" },
      { label: "The Venue Collective", href: "/venue-collective" },
      { label: "Create event", href: "/create" },
      { label: "Reporting & analytics", href: "/reporting" },
      { label: "Custom event sites", href: "/site-pages" },
      { label: "Hotel room blocks", href: "/hotel-room-blocks" },
      { label: "Marketing activations", href: "/activations" },
      { label: "Games", href: "/games" },
    ],
  },
  {
    heading: "Resources",
    links: [
      { label: "Case studies", href: "/case-studies" },
      { label: "Blog", href: "/blogs" },
      { label: "Comparisons", href: "/comparisons" },
      { label: "Templates", href: "/templates" },
      { label: "Support", href: "/support" },
      { label: "Status", href: "https://status.nowadays.ai/" },
      { label: "Community", href: "/community" },
      { label: "Changelog", href: "/changelog" },
      { label: "Newsletter", href: "/newsletter" },
      { label: "FAQs", href: "/faq" },
      { label: "Glossary", href: "/glossary" },
    ],
  },
];

/** Legal links in the footer's bottom bar, beside the copyright. */
export const FOOTER_LEGAL_LINKS: FooterLink[] = [
  { label: "Terms", href: "/terms-of-service" },
  { label: "Privacy", href: "/privacy-policy" },
];
